export enum Route {
  MAIN_SCREEN = "main",
  NOT_FOUND = "not_found",
}
